export default __webpack_public_path__ + "b6a4d5a9e3361182ea844b6b13876785.svg";